import React from "react";
import data from "../data";
import { Link } from "react-router-dom";

const FAQ = () => {
  return (
    <div className="container mx-auto px-6 py-12 sm:px-8 md:px-12 lg:px-16 xl:px-60">
      <h1 className="text-5xl font-bold text-primary text-center mb-8">
        Frequently Asked Questions
      </h1>
      <p className="text-lg text-gray-700 text-center max-w-3xl mx-auto mb-12">
        Here you will find answers to the 10 questions we are most frequently
        asked. If you still have questions,{" "}
        <Link
          to="/contact"
          className="text-primary underline hover:text-secondary"
        >
          contact us
        </Link>
        . We are happy to help!
      </p>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        {data.faq.questions.map((item, index) => (
          <div key={index} className="p-6 border rounded-lg shadow-lg bg-white">
            <h3 className="text-xl font-semibold text-primary mb-4">
              {item.question}
            </h3>
            <p className="text-gray-600">{item.answer}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FAQ;
